import React, { useCallback, useEffect, useState } from 'react';
import { KoobInputSegmented, KoobPageHeader } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import LibraryFilters from './LibraryFilters';
import { FiltersCard } from '../../../components/Filters';
import LibraryActiveFilters from './LibraryActiveFilters';
import TripCard from 'components/Trip/TripCard';
import TripList, { buildTripRequestFilters } from 'components/Trip/TripList';
import { useAsync } from 'react-async';
import { getTags } from '../../../api/tag';
import KoobLayout from '../../../components/Koob/KoobLayout';
import { useLibraryFilters, useSetLibraryFilters } from '@koob/trip-designer';

export default function TripsList() {
  const { t } = useTranslation('tripDesigner');
  const libraryFilters = useLibraryFilters();
  const setLibraryFilters = useSetLibraryFilters();

  const [tags, setTags] = useState([]);
  const [total, setTotal] = useState();
  const { data: tagsData, reload: reloadTags } = useAsync({
    promiseFn: getTags,
    scope: 'Trip',
  });

  useEffect(() => {
    setTags(tagsData?.data ?? []);
  }, [tagsData]);

  const updateFilterValue = useCallback(
    (property, value) => {
      setLibraryFilters(current => ({
        ...current,
        [property]: value,
      }));
    },
    [setLibraryFilters],
  );

  const type = libraryFilters?.type ?? 'trip';

  return (
    <KoobLayout
      header={
        <KoobPageHeader
          title={t('pages:library')}
          subtitle={
            total !== undefined && t('library.results', { count: total })
          }
        />
      }
    >
      <FiltersCard bar={<LibraryFilters tags={tags} />}>
        <LibraryActiveFilters />

        <div>
          <KoobInputSegmented
            options={[
              { value: 'trip', label: t('search.trips') },
              { value: 'template', label: t('search.templates') },
            ]}
            value={type}
            onChange={value => updateFilterValue('type', value)}
          />
        </div>

        <div className="mt-5">
          <TripList
            filters={buildTripRequestFilters(libraryFilters, {
              type,
              onlyFavorites: libraryFilters?.onlyFavorites ?? false,
            })}
            onTotalChange={setTotal}
            renderCard={(trip, reload) => (
              <TripCard
                trip={trip}
                reload={reload}
                enableChat={type === 'trip'}
                enableFavorite
                enableTagsEdition
                enableExport
                enableReceipt={type === 'trip'}
                tags={tags}
                reloadTags={reloadTags}
              />
            )}
          />
        </div>
      </FiltersCard>
    </KoobLayout>
  );
}
